module.exports = __webpack_public_path__ + "static/img/hua8.a081819.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua8.png
// module id = I+Bt
// module chunks = 22